import type { ReactDatePickerProps } from 'react-datepicker/index';
import { lazyRetry } from 'src/util/retry';
import { Tooltip } from '../Tooltip';
import { CalendarIcon, Container, IconContainer, InputContainer, Label, RequiredText } from './styles';

const DatePicker = lazyRetry(() => import('./DatePickerInput'));

export interface IDateInputProps extends ReactDatePickerProps<string, boolean> {
  label?: string;
  tooltip?: string;
  light?: boolean;
}

export const DateInput = ({ label, tooltip, className, light, placeholderText, ...props }: IDateInputProps) => (
  <Container className={className}>
    {(label || tooltip) && (
      <Label>
        {props.required ? (
          <span>
            {label}
            <RequiredText>*</RequiredText>
          </span>
        ) : (
          label
        )}
        {tooltip && <Tooltip content={tooltip} showInfoCircle />}
      </Label>
    )}

    <InputContainer light={light}>
      <IconContainer>
        <CalendarIcon />
      </IconContainer>
      <DatePicker dateFormat='MM/dd/yyyy' placeholderText={placeholderText ?? label} timeIntervals={15} {...props} />
    </InputContainer>
  </Container>
);

export default DateInput;
